<template>
    <div class="mb-6 flex flex-col gap-3">
        <!-- Title -->
        <div class="text-sm font-semibold">
            {{ $t('titleist.logoball.title') }}
        </div>

        <!-- Description -->
        <div class="text-xs text-base-content-subtle leading-5">
            {{ $t('titleist.logoball.description') }}
        </div>

        <!-- Input Fields -->
        <div class="flex flex-col gap-3">
            <!-- Row 1 (Required) -->
            <label for="logoball-row-1" class="form-control w-full">
                <div class="label">
                    <span class="label-text">{{ $t('titleist.logoball.row1Label') }} *</span>
                </div>
                <input
                    id="logoball-row-1"
                    ref="row1Input"
                    v-model="row1"
                    type="text"
                    :placeholder="$t('titleist.logoball.placeholder')"
                    class="input input-bordered w-full text-sm"
                    required
                    maxlength="15"
                    :pattern="inputPattern"
                    @input="updateModelValue"
                >
            </label>

            <!-- Row 2 (Optional) -->
            <label for="logoball-row-2" class="form-control w-full">
                <div class="label">
                    <span class="label-text">{{ $t('titleist.logoball.row2Label') }}</span>
                </div>
                <input
                    id="logoball-row-2"
                    v-model="row2"
                    type="text"
                    :placeholder="$t('titleist.logoball.placeholder')"
                    class="input input-bordered w-full text-sm"
                    maxlength="15"
                    :pattern="inputPattern"
                    @input="updateModelValue"
                >
            </label>

            <!-- Row 3 (Optional) -->
            <label for="logoball-row-3" class="form-control w-full">
                <div class="label">
                    <span class="label-text">{{ $t('titleist.logoball.row3Label') }}</span>
                </div>
                <input
                    id="logoball-row-3"
                    v-model="row3"
                    type="text"
                    :placeholder="$t('titleist.logoball.placeholder')"
                    class="input input-bordered w-full text-sm"
                    maxlength="15"
                    :pattern="inputPattern"
                    @input="updateModelValue"
                >
            </label>
        </div>

        <!-- Important Note -->
        <div class="text-xs bg-warning text-warning-content p-3">
            <span class="font-semibold">{{ $t('titleist.logoball.importantNoteTitle') }}</span>
            {{ $t('titleist.logoball.importantNoteText') }}
            <MiscLink :to="$t('titleist.logoball.cancellationLink')" class="link font-semibold">
                {{ $t('titleist.logoball.cancellationLinkText') }}
            </MiscLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

defineProps<{
    modelValue: Partial<Schemas['TitelistLogoballPayload']>
}>()

const emit = defineEmits<{
    'update:modelValue': [value: Schemas['TitelistLogoballPayload']]
}>()

const { t } = useI18n()

const inputPattern = '[A-ZÄÜÖa-zäüö0-9.,&=#?!+\\-éèêàçìòùÀÁÂÃĄĀĆČÇĎÉÊĚĘĖĒËÍĪÏĮĶĹĽĻŁŇŅÑÓÔÕŔŘŠŚŤÚŪŲŮÝŽŻŹÅÆØŃĢáâãąāćčďěęėēëíīïįķĺľļłňņñóôõŕřšśťúūųůýžżźåæøńģ\\s]*'

const row1 = ref('')
const row2 = ref('')
const row3 = ref('')
const row1Input = ref<HTMLInputElement | null>(null)

function updateModelValue() {
    if (row1Input.value) {
        row1Input.value.setCustomValidity(row1.value.trim() === '' && row1.value.length > 0 ? t('titleist.logoball.row1SpacesError') : '')
    }
    emit('update:modelValue', {
        logoball_customer_input_row_1: row1.value,
        logoball_customer_input_row_2: row2.value,
        logoball_customer_input_row_3: row3.value
    })
}
</script>
